import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _fetchMatch } from "../modules/matches";
import { matchActionHandler } from "../match/matchActionHandler";
import type { MatchState } from "../match/types";

function MatchStatsScene({ player0, player1, player0Stats, player1Stats }) {

  function posSuccess(p: PlayerStats) {
    const summary = p.breaks.reduce((prev, b) => ({
      total: prev.total + b.balls,
      success: prev.success + (b.balls - 1)
    }), {
      total: 0,
      success: 0
    });

    if (summary.total === 0) {
      return 0;
    }
    return summary.success / summary.total;
  }

  function ballsPotted(p: PlayerStats) {
    return p.breaks.reduce((prev, b) => prev + b.balls, 0);
  }

  return (
    <div>
      <span>MATCH STATS</span>
        <div>
          <span>{player0.name.toUpperCase()}</span>
          <span>VS</span>
          <span>{player1.name.toUpperCase()}</span>
        </div>
        <div>
          <span>AVERAGE SCORE FOLLOWING A RED</span>
        </div>
        <div>
          <div >
            <span>{ player0Stats.valuesFollowingRed.length >= 1 ? (player0Stats.valuesFollowingRed.reduce((prev, n) => prev + n) / player0Stats.valuesFollowingRed.length).toFixed(1) : 'N/A' }</span>
          </div>
          <div >
            <span>{ player1Stats.valuesFollowingRed.length >= 1 ? (player1Stats.valuesFollowingRed.reduce((prev, n) => prev + n) / player1Stats.valuesFollowingRed.length).toFixed(1) : 'N/A' }</span>
          </div>
        </div>

        <div>
          <span>POSITION SUCCESS</span>
        </div>
        <div>
          <div >
            <span>{ (100*posSuccess(player0Stats)).toFixed(1) }%</span>
          </div>
          <div >
            <span>{ (100*posSuccess(player1Stats)).toFixed(1) }%</span>
          </div>
        </div>

        <div>
          <span>BALLS POTTED</span>
        </div>
        <div>
          <div >
            <span>{ ballsPotted(player0Stats) }</span>
          </div>
          <div >
            <span>{ ballsPotted(player1Stats) }</span>
          </div>
        </div>

        <div>
          <span>FOULS CONCEDED</span>
        </div>
        <div>
          <div >
            <span>{ player0Stats.foulsConceded.length } ({ player0Stats.foulsConceded.reduce((tot, f) => tot + f, 0) } points)</span>
          </div>
          <div >
            <span>{ player1Stats.foulsConceded.length } ({ player1Stats.foulsConceded.reduce((tot, f) => tot + f, 0) } points)</span>
          </div>
        </div>

        <div>
          <span>TOP BREAKS</span>
        </div>
        <div>
          <div >
            { player0Stats.breaks.sort((a, b) => b.total - a.total).map(b => <div key={b.startTime}>{b.total}</div>) }
          </div>
          <div >
            { player1Stats.breaks.sort((a, b) => b.total - a.total).map(b => <div key={b.startTime}>{b.total}</div>) }
          </div>
        </div>
    </div>
  );
}

class Match extends Component {
  state = {
    match: null,
  };

  componentDidMount() {

    _fetchMatch(this.props.id).then(match => this.setState({ match }));
  }

  componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ match: null });
      _fetchMatch(props.id).then(match => this.setState({ match }));
    }
  }

  render() {
    const { match } = this.state;
    if (!match) return <p>Loading</p>;

    let matchState: MatchState = null;
    match.actions.forEach(action => {
      matchState = matchActionHandler(matchState, action);
    });



    return (
      MatchStatsScene({ ...matchState, player0: match.players[0], player1: match.players[1] })
    );
  }
}

export default connect((state, props) => {
  const { navigation } = state;
  const { id } = navigation.routes[navigation.index].params;

  return {
    id
  };
})(Match);



// WEBPACK FOOTER //
// ./src/scenes/Match.js